import React from "react";

export default class CustomNodeWidget extends React.Component {
    /**
     * Normal node view wrapper with mouse and custom event handling
     * @module CustomNodeWidget
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.state = {};
        this.eventHandle = this.handleEvent.bind(this);
    }

    /**
     * Selective updates for improved performance
     * @returns {boolean}
     */
    shouldComponentUpdate() {
        return this.props.diagramEngine.canEntityRepaint(this.props.node);
    }

    componentDidMount(){
        document.addEventListener('ev-node-select', this.eventHandle);
        document.addEventListener('ev-update-focus', this.eventHandle);
    }

    componentWillUnmount() {
        document.removeEventListener('ev-update-focus', this.eventHandle);
        document.removeEventListener('ev-node-select', this.eventHandle);
    }

    /**
     * Handle custom events
     * @param {Object} event Document CustomEvent
     */
    handleEvent(event){
        if (event.type === "ev-update-focus"){
            if (event.detail === this.props.diagramEngine.clientId){
                document.addEventListener('ev-node-select', this.eventHandle);
            } else {
                document.removeEventListener('ev-node-select', this.eventHandle);
            }
        } else if (event.type === "ev-node-select"){
            if (event.detail === this.props.node.getID()){
                this.forceUpdate();
            }
        }
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        const childWithProp = React.Children.map(this.props.children, (child) => {
            return React.cloneElement(child, {readOnly: this.props.readOnly}, {isCommonModule: this.props.isCommonModule});
        });
        return (
            <div
                data-nodeid={this.props.node.id}
                className={"node" + (this.props.node.isSelected() ? " selected" : "")}
                style={{
                    top: this.props.node.y,
                    left: this.props.node.x
                }}
                >
                {childWithProp}
            </div>
        );
    }
}
